(() => {
  document.addEventListener('click', event => {
    const button = event.target.closest('.cart-item-quantity .quantity-up');
    if (!button) return;
    const input = button.parentElement.querySelector('input[name="updates[]"]');
    if (input && input.max !== '' && Number(input.value) + Number(input.step || 1) > Number(input.max)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  const checkQuantity = event => {
    const input = event.target;
    if (!input.matches('.cart-item-quantity input[name="updates[]"]') || input.max === '') return;
    if (Number(input.value) <= Number(input.max)) return;
    input.value = input.dataset.initial || input.max;
    event.stopImmediatePropagation();
    const row = input.closest('tr, .media-link');
    const notice = row?.querySelector('[data-mev-quantity-notice]');
    if (notice) {
      notice.textContent = input.dataset.mevQtyLimitMessage;
      notice.hidden = false;
    }
  };
  document.addEventListener('input', checkQuantity, true);
  document.addEventListener('change', checkQuantity, true);
  const showJulebodyView = mode => {
    const gallery = document.querySelector('[data-mev-julebody-gallery]');
    if (!gallery) return;
    gallery.dataset.view = mode;
    gallery.querySelectorAll('[data-mev-body-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mevBodyView === mode)));
    gallery.querySelector('.mev-julebody-live-preview')?.setAttribute('aria-hidden', String(mode !== 'preview'));
    if (mode === 'preview') window.dispatchEvent(new Event('resize'));
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-mev-body-view]');
    if (button) showJulebodyView(button.dataset.mevBodyView);
  });
  document.addEventListener('focusin', event => {
    if (event.target.matches('.tee-field--text input, .tee-field textarea')) showJulebodyView('preview');
  });
  document.addEventListener('change', event => {
    if (event.target.matches('.tee-option input, .tee-field input, .tee-field textarea')) showJulebodyView('preview');
  });
  const translateAppLabels = () => {
    const info = document.querySelector('[data-mev-bauble-order-info]');
    const actions = document.getElementById('teeFormActions');
    if (info && actions && info.nextElementSibling !== actions) actions.before(info);
    const label = window.mevUiLabels?.quantity;
    if (!label) return;
    document.querySelectorAll('.tee-quantity-input').forEach(input => {
      input.setAttribute('aria-label', label);
      input.setAttribute('placeholder', label);
    });
    document.querySelectorAll('.tee-field__title').forEach(title => {
      if ((title.textContent || '').replace(/\s+/g, ' ').trim() === 'Quantity' && title.textContent !== label) title.textContent = label;
    });
  };
  document.addEventListener('teeinblue-event-component-injected', () => {
    translateAppLabels();
  });
  const syncProductShares = () => {
    document.querySelectorAll('[data-product-share]').forEach(share => {
      const section = share.closest('.shopify-section');
      const selected = section?.querySelector('variant-selects:not(.sticky-bar-product-options) [data-selected-variant]');
      if (!selected) return;
      let variant;
      try { variant = JSON.parse(selected.textContent); } catch { return; }
      if (!variant?.id) return;
      const productUrl = new URL(share.dataset.shareBaseUrl, document.baseURI);
      productUrl.searchParams.set('variant', variant.id);
      const imageSource = variant.featured_image?.src || variant.featured_media?.preview_image?.src || share.dataset.shareFallbackImage;
      let imageUrl = null;
      if (imageSource) {
        imageUrl = new URL(imageSource, document.baseURI);
        imageUrl.searchParams.set('width', '1024');
      }
      share.querySelectorAll('[data-share-network]').forEach(link => {
        const url = new URL(link.href, document.baseURI);
        url.searchParams.set(link.dataset.shareNetwork === 'facebook' ? 'u' : 'url', productUrl.href);
        if (link.dataset.shareNetwork === 'pinterest') {
          if (imageUrl) url.searchParams.set('media', imageUrl.href);
          else url.searchParams.delete('media');
        }
        if (link.href !== url.href) link.href = url.href;
      });
    });
  };
  const startTranslations = () => {
    translateAppLabels();
    syncProductShares();
    new MutationObserver(records => {
      if (records.some(record => record.target.parentElement?.closest('variant-selects') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('variant-selects, [data-product-share]') || node.querySelector('variant-selects, [data-product-share]'))))) syncProductShares();
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.tee-field__title') || node.querySelector('.tee-field__title'))))) translateAppLabels();
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startTranslations);
  else startTranslations();
})();
